const whitelistDomains = {
  dev_au: ['https://dev.leap365.com.au', 'https://dev.leapjd.com.au'],
  test_au: [
    'https://test.leap365.com.au',
    'https://test-epic1.leap365.com.au',
    'https://reporting-test.leapaws.com.au',
    'https://reporting-dev.leapaws.com.au',
    'https://leapcalc-renderer-au-test.leap.services',
    'https://test.leapjd.com.au',
    'https://test.leapjd.co.nz',
    'https://tauri.test.leap365.com.au', // temporary use, can remove once it's done
  ],

  live_au: [
    'https://staging.leap365.com.au',
    'https://sandbox.leap365.com.au',
    'https://app.leap365.com.au',
    'https://reporting.leapaws.com.au',
    'https://leapcalc-renderer-au-live.leap.services',
  ],

  liveb_au: ['https://staging.liveb.leap365.com.au', 'https://liveb.leap365.com.au'],

  test_uk: [
    'https://test.leap365.co.uk',
    'https://reporting-test.leapaws.co.uk',
    'https://leapcalc-renderer-uk-test.leap.services',
    'https://test.leapjd.co.uk',
  ],

  live_uk: [
    'https://app.leap365.co.uk',
    'https://staging.leap365.co.uk',
    'https://sandbox.leap365.co.uk',
    'https://reporting.leapaws.co.uk',
    'https://leapcalc-renderer-uk-live.leap.services',
  ],

  test_us: [
    'https://test.leap365.com',
    'https://reporting-test.leapaws.com',
    'https://leapcalc-renderer-us-test.leap.services',
    'https://test.leapjd.com',
  ],

  live_us: [
    'https://app.leap365.com',
    'https://staging.leap365.com',
    'https://sandbox.leap365.com',
    'https://reporting.leapaws.com',
    'https://leapcalc-renderer-us-live.leap.services',
  ],

  test_ca: [
    'https://test.leap365.ca',
    'https://reporting.test.leapaws.ca',
    'https://renderer.test.ca.leap.services',
    'https://test.leapjd.ca',
  ],

  live_ca: [
    'https://app.leap365.ca',
    'https://staging.leap365.ca',
    'https://sandbox.leap365.ca',
    'https://reporting.leapaws.ca',
    'https://renderer.ca.leap.services',
  ],

  test_nz: ['https://test.leap365.co.nz'],

  live_nz: ['https://staging.leap365.co.nz', 'https://app.leap365.co.nz'],
};

const qeDomains = ['https://automationactionlauncher.test.leap365.com', 'https://automationactionlauncher.leap365.com'];

const devDomains = [
  'http://localhost:53504', // local url for reporting
  'http://localhost:8080', // local url for leap web
  'http://localhost:9005', // local url for tester app
];

const leapHostTestAppDomain = 'https://leaphost.test.leap365.com.au';

const jd = 'http://my.leapjd';

export { whitelistDomains, qeDomains, devDomains, leapHostTestAppDomain, jd };
